import * as React from 'react';

declare const require: any;
const $: any = require('jquery');
let prevClass = '';

export class Table extends React.Component<{params: {table: string}}, {dialog: boolean, code: string, error: string, sent: boolean}> {
    constructor(props) {
        super(props);
        this.state = {
            sent: false,
            code: '',
            error: '',
            dialog: false
        };
    }
    
    componentWillMount() {
        prevClass = document.body.className;
        document.body.className += ' desk';
    }
    
    componentWillUnmount() {
        document.body.className = prevClass;
    }
    
    private showVoteDialog(e) {
        e.preventDefault();
        this.setState({code: this.state.code, error: this.state.error, dialog: true, sent: this.state.sent});
    }
    
    private updateCode(e) {
        this.setState({code: e.target.value, error: '', dialog: this.state.dialog, sent: this.state.sent});
    }
    
    private sendVote(e) {
        $.post('/reg/vote', {table: this.props.params.table, code: this.state.code}, data => {
            if (data === true) {
                this.setState({code: this.state.code, error: '', dialog: this.state.dialog, sent: true});
            } else {
                this.setState({code: this.state.code, error: data.error, dialog: this.state.dialog, sent: false});
            }
        }, 'json');
    }
    
    private reset(e) {
        this.setState({code: '', error: '', dialog: false, sent: false});
    }
    
    public render() {
        return (
            <div className="desk-table">
                <h1>Голосование<br/> за лучшую систему</h1>
                
                <h2>Стол № {this.props.params.table}</h2>
                
                <div className="initial">
                    <button onClick={e => this.showVoteDialog(e)} type="button">Проголосовать</button>
                </div>
                
                <div ref="vote-dialog" className="vote-dialog" style={{display: this.state.dialog ? 'block':'none'}}>
                    {!this.state.sent
                        ? <div>
                                {this.state.error ? <h4>{this.state.error}</h4> : <h3>Укажите регистрационный код</h3>}
                                <p><input type="number" onChange={e => this.updateCode(e)} value={this.state.code} /></p>
                                <p><button type="button" onClick={e => this.sendVote(e)}>Отправить</button></p>
                        </div>
                        : <div>
                            <h3>Спасибо! Ваш голос учтен!</h3>
                            <p><button type="button" onClick={e=>this.reset(e)} className="close">Закрыть</button></p>
                        </div>
                    }
                </div>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/route/Table.tsx
 **/